import { useEffect, useState } from 'react';
import { Button, Popconfirm, Switch } from 'antd';
import AntButton from '../../components/AntButton/AntButton'; // Make sure to import AntButton

const useAntTable = (props) => {
  const [rows, setRows] = useState([]);
  const [popConfButtClicked, setPopConfButtClicked] = useState(false);

  useEffect(() => {
    setRows(props.data || []);
  }, [props.data]);

  const onChangeSwitch = (e, id) => {
    const updatedRows = rows.map((row) => {
      if (row.id === id) {
        return { ...row, status: e ? 'enabled' : 'disabled' };
      }
      return row;
    });
    setRows(updatedRows);
  };

  const cancel = (e) => {};

  const generateColumns = () => {
    if (rows.length === 0) {
      return [];
    }

    const columns = Object.keys(rows[0])
      .filter((key) => key.toLowerCase() !== 'id' && key.toLowerCase() !== 'status')
      .map((key) => ({
        title: key
          .replace(/([a-z])([A-Z])/g, '$1 $2')
          .replace(/\s+/g, ' ')
          .trim()
          .toUpperCase(),
        dataIndex: key,
      }));

    if (props.updateFn) {
      columns.push({ title: '', dataIndex: 'updateFn', width: 100 });
    }
    if (props.deleteFn) {
      columns.push({ title: '', dataIndex: 'deleteFn', width: 100 });
    }
    if (props.previewFn) {
      columns.push({ title: '', dataIndex: 'previewFn', width: 100 });
    }
    if (props.switcherFn) {
      columns.push({ title: '', dataIndex: 'switcherFn', width: 100 });
    }

    return columns;
  };

  const generateRows = () => {
    if (!props.updateFn && !props.deleteFn && !props.switcherFn && !props.previewFn) {
      return rows;
    }

    return rows.map((element) => {
      let row = { ...element };

      // Add Edit function column with AntButton
      if (props.updateFn) {
        row = { ...row, updateFn: <Button type="primary" onClick={() => props.updateFn(element.id)}>Edit</Button> };
      }

      // Add Delete function column with Popconfirm
      if (props.deleteFn) {
        row = {
          ...row,
          deleteFn: (
            <Popconfirm
              title="Delete the Item"
              description="Are you sure to delete this Item?"
              onConfirm={() => props.deleteFn(element.id)}
              onCancel={cancel}
              okText="Yes"
              cancelText="No"
            >
              <Button color="danger" variant="link" onClick={() => { }}>Delete</Button>
            </Popconfirm>
          ),
        };
      }

      // Add preview function column with AntButton
      if (props.previewFn) {
        row = { ...row, previewFn: <AntButton type="link" text="Preview" onClick={() => props.previewFn(element.id)} /> };
      }

      // Add Switch function column with Popconfirm
      if (props.switcherFn) {
        const statusToToggle = element?.status === 'enabled' ? 'Enable' : 'Disable';
        const msg = `Are you sure you want to ${statusToToggle} the item?`;

        row = {
          ...row,
          switcherFn: (
            <Popconfirm
              title={`${element?.status === 'enabled' ? 'Enable' : 'Disable'} the Item`}
              description={msg}
              onConfirm={() => {
                props.switcherFn(element);
                setPopConfButtClicked(true);
              }}
              onCancel={() => {
                setRows(props.data);
                setPopConfButtClicked(true);
              }}
              okText="Yes"
              cancelText="No"
              onOpenChange={(e) => {
                if (!e && !popConfButtClicked) {
                  setRows(props.data);
                }
                if (e) {
                  setPopConfButtClicked(false);
                }
              }}
            >
              <Switch
                checkedChildren="enabled"
                unCheckedChildren="disabled"
                checked={element?.status === 'enabled'}
                defaultChecked={element?.status === 'enabled'}
                onChange={(e) => {
                  onChangeSwitch(e, element.id);
                }}
              />
            </Popconfirm>
          ),
        };
      }

      return row;
    });
  };
  
  return {
    generateColumns,
    generateRows,
  };
};

export default useAntTable;
